import React from 'react';
import {
  Enterprise,
  EntityWithDecisionsToShow,
} from '../../entity/entity.types';
import { EnterpriseList } from '../../entity/entity-lists/EnterpriseList';
import { EntityModalLoader } from '../../components/entity-modal-placeholder/EntityModalLoader';
import { fetchEnterprises } from '../../lawyer/lawyer.api';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
} from '../../components/modal';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { EntityDecisionListModalWithGoBack } from './EntityDecisionListModalWithGoBack';

type Props = {
  wording: string;
  lawyerId: string;
  source: string;
  lawyerName: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

type State = {
  allEnterprises: Array<Enterprise>;
  isLoading: boolean;
  entityWithDecisionsToShowInfos: EntityWithDecisionsToShow | null | undefined;
};

export class AllLawyerEnterprisesModal extends React.Component<Props, State> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  state: State = {
    allEnterprises: [],
    isLoading: true,
    entityWithDecisionsToShowInfos: null,
  };

  async componentDidMount() {
    const { enterprises: allEnterprises } = (
      await fetchEnterprises(this.props.lawyerId, true)
    ).data;
    this.setState({ allEnterprises, isLoading: false });
  }

  handleClickDecision = (enterprise: Enterprise) => {
    this.setState({
      entityWithDecisionsToShowInfos: {
        name: enterprise.name,
        params: {
          lawyerId: this.props.lawyerId,
          siren: enterprise.siren,
        },
      },
    });
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: `${this.props.source}_modal`,
    });
  };

  handleGoBack = () => {
    this.setState({ entityWithDecisionsToShowInfos: null });
  };

  render() {
    const { onRequestClose, lawyerName, source, wording, isOpen } = this.props;
    const {
      isLoading,
      allEnterprises,
      entityWithDecisionsToShowInfos,
    } = this.state;
    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        {entityWithDecisionsToShowInfos ? (
          <EntityDecisionListModalWithGoBack
            entityWithDecisionsToShowInfos={entityWithDecisionsToShowInfos}
            wording={wording}
            closeModal={onRequestClose}
            handleGoBack={this.handleGoBack}
            source={source}
          />
        ) : (
          <>
            <ModalScrollableHeader
              title={`Entreprises représentées par Maître ${lawyerName}`}
              onClose={onRequestClose}
            />
            <ModalScrollableContent>
              <EntityModalLoader isLoading={isLoading}>
                <EnterpriseList
                  enterprises={allEnterprises}
                  source={`${source}_modal_list`}
                  wording={wording}
                  handleClickDecision={this.handleClickDecision}
                  fromModal
                />
              </EntityModalLoader>
            </ModalScrollableContent>
          </>
        )}
      </ModalScrollableContainer>
    );
  }
}
